import { gql } from "@apollo/client";

export const findCommunicationTemplateByIdQueue = gql`
    query findCommunicationTemplateById($id: String!) {
        findCommunicationTemplateById(id: $id) {
            id
            friendlyId
            name
            description
            channel
            state
            emailSubject
            body
            bodySource
            teams {
                id
                name
            }
        }
    }
`;
